import { defineComponent as _defineComponent } from 'vue'
import { emitter, MittType } from "@/plugins/event-bus";
import { ref, computed } from "vue";
import { useAuth } from "vue-auth3";
import Logo from "@/components/Logo.vue";
import MenuPanel from "@/components/MenuPanel.vue";
import mixins from "@/mixins";
import router from "@/router";
import type { DropdownInstance } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'Layout',
  setup(__props, { expose: __expose }) {
  __expose();

const auth = useAuth();
const appVersion: string = process.env.VUE_APP_VERSION;
const loginMenu = ref<DropdownInstance>();
emitter.on(MittType.autofocus, () => mixins.triggerFocus());
emitter.on(MittType.tabChange, () => mixins.triggerRepaintGrids());

window.addEventListener("resize", () => emitter.emit(MittType.resize));

function getYear() {
  return mixins.formatDate(new Date(), "YYYY");
}

function showUserMenu() {
  if (!loginMenu.value) return;
  loginMenu.value.handleOpen();
}

function logout() {
  auth.logout({
    makeRequest: false,
    redirect: { name: "login" },
  });
}

function redirectLogin() {
  router.push("login");
}
const userName = computed(() => {
  return (auth.state.data && (auth.state.data.name || auth.state.data.email)) || "empty";
});
const userEmail = computed(() => {
  return auth.state.data && auth.state.data.email;
});
const userLocation = computed(() => {
  return auth.state.data && [auth.state.data.country, auth.state.data.location].filter((x) => x).join(", ");
});

const __returned__ = { auth, appVersion, loginMenu, getYear, showUserMenu, logout, redirectLogin, userName, userEmail, userLocation, Logo, MenuPanel, get mixins() { return mixins } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})